"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
require("./style.sass");
var TextArea = function (props) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { style: {
            margin: '0.31rem 0',
            display: 'flex',
            flex: 1,
            width: '100%',
            flexDirection: 'column',
        } },
        props.error && react_1.default.createElement("p", { className: 'error' }, t(props.error.toString())),
        react_1.default.createElement("div", { className: 'input-label', style: props.InputLabelStyle },
            react_1.default.createElement("label", { className: 'label' }, props.label),
            react_1.default.createElement("div", { className: 'textInputContainer', style: props.TextAreaStyle },
                react_1.default.createElement("textarea", { className: 'textAreaContainer', onChange: props.onChange, placeholder: props.placeholder, rows: 6, value: props.value })))));
};
exports.default = TextArea;
